import { useAuth } from "@/components/AuthProvider";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Camera, User } from "lucide-react";

interface ProfileHeaderProps {
  firstName: string | null;
  lastName: string | null;
  avatarUrl: string | null;
  email: string | null;
  onAvatarChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ProfileHeader({ firstName, lastName, avatarUrl, email, onAvatarChange }: ProfileHeaderProps) {
  const displayName = firstName && lastName 
    ? `${firstName} ${lastName}` 
    : firstName || lastName || "Anonymous";

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <Avatar className="h-24 w-24">
          <AvatarImage src={avatarUrl || undefined} alt={displayName} />
          <AvatarFallback className="bg-primary/10">
            <User className="h-12 w-12 text-primary/60" />
          </AvatarFallback>
        </Avatar>
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2">
          <input
            type="file"
            id="avatar-upload"
            className="hidden"
            accept="image/*"
            onChange={onAvatarChange}
          />
          <Button 
            variant="outline" 
            size="sm" 
            className="gap-1.5"
            onClick={() => document.getElementById('avatar-upload')?.click()}
          >
            <Camera className="h-3.5 w-3.5" />
            <span className="text-xs">Change</span>
          </Button>
        </div>
      </div>
      <div className="text-center">
        <h3 className="font-medium">{displayName}</h3>
        <p className="text-sm text-muted-foreground">{email}</p>
      </div>
    </div>
  );
}